export default {
    imageDashboardTransaction: {
        action: 'Toiminta',
        transactionId: 'Tapahtuman tunnus',
        variationCount: 'Muunnelmien määrä',
        date: 'Päiväys',
        cost: 'Hinta',
        description: 'Kuvaus',
        selectedImage: 'Valittu kuva',
        goTo: 'Mene',
    },
};
